const lazyPageComponent = () => import('@/Pages/Ru/TechStack.vue');

export const techStackRoutes = [
  {
    path: '/tech-stack',
    pathname: '/tech-stack',
    name: 'tech-stack',
    component: lazyPageComponent,
    meta: {
      name: 'tech-stack',
    },
  },
];
